import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IChatWidgetHistoryService = ( createDecorator('IChatWidgetHistoryService'));
export { IChatWidgetHistoryService };
